<template>
  <div class="author">
    <div class="author_nav">

    1233312312321
    </div>

      <div class="author_nav">
    123123
      

      </div>

  </div>
</template>


<script>

 export default {
   components:{
    
   },
  data () {
    return {

    }
  },
  methods:{

    //初始化页面


  },
  computed: {

  },
  created(){


  }
}
</script>

<style lang="scss" scoped>

.author{
  width: 65%;
  // min-width: 900px;
  background-color: #F7F8FA;
  padding-top: 40px;
  
  .author_nav{
    // width: 60%;
  // min-width: 900px;
    // margin: 0 auto;
    overflow: hidden;
    margin-left: 5%;
    border:1px solid #ccc;


  }
}


</style>



// WEBPACK FOOTER //
// src/components/public/home/homeRight.vue